export default "__VITE_ASSET__4aa6fdf0__"